function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.reddit_st0{fill:#FF4500;}\n\t.reddit_st1{fill:#FFFFFF;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "reddit_st0",
  cx: 256,
  cy: 256,
  r: 256
}), /*#__PURE__*/React.createElement("path", {
  className: "reddit_st1",
  d: "M426.7,256c0-20.3-17.1-37.3-37.3-37.3c-9.6,0-19.2,4.3-25.6,10.7c-25.6-18.1-60.8-29.9-100.3-32l17.1-80 l55.5,11.7c1.1,13.9,11.7,25.6,26.7,25.6c14.9,0,26.7-11.7,26.7-26.7s-11.7-26.7-26.7-26.7c-10.7,0-19.2,6.4-23.5,14.9l-61.9-12.8 c-2.1,0-3.2,0-5.3,1.1c-1.1,1.1-2.1,2.1-3.2,4.3l-19.2,89.6c-39.5,1.1-75.7,12.8-101.3,32c-6.4-6.4-16-10.7-25.6-10.7 c-20.3-1.1-37.3,16-37.3,36.3c0,14.9,8.5,27.7,22.4,34.1c-1.1,3.2-1.1,7.5-1.1,11.7c0,56.5,67.2,103.5,149.3,103.5 s149.3-46.9,149.3-104.5c0-4.3,0-7.5-1.1-11.7C417.1,284.8,426.7,270.9,426.7,256z M170.7,282.7c0-14.9,11.7-26.7,26.7-26.7 s26.7,11.7,26.7,26.7c0,14.9-11.7,26.7-26.7,26.7S170.7,297.6,170.7,282.7z M318.9,353.1c-18.1,18.1-53.3,19.2-62.9,19.2 c-10.7,0-44.8-1.1-62.9-19.2c-3.2-3.2-3.2-7.5,0-9.6c3.2-3.2,7.5-3.2,9.6,0c11.7,11.7,36.3,16,53.3,16s41.6-4.3,53.3-16 c3.2-3.2,7.5-3.2,9.6,0C322.1,345.6,322.1,350.9,318.9,353.1z M314.7,309.3c-14.9,0-26.7-11.7-26.7-26.7 c0-14.9,11.7-26.7,26.7-26.7c14.9,0,26.7,11.7,26.7,26.7C341.3,297.6,329.6,309.3,314.7,309.3z"
}));

function SvgReddit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReddit);
export default __webpack_public_path__ + "static/media/reddit.4c691c96.svg";
export { ForwardRef as ReactComponent };